import {useState,useRef} from "react"
import { IconButton } from "@mui/material"
import Box from "@mui/material/Box"
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import ERPSnakBar from "./ERPSnakBar";
import { updatePaymentStatusAndRemarks } from "../services/shipDataService";

function UpdatePaymentStatusAndRemarks({fieldName,cellValue,keyValue,getUpdateList}:{fieldName:string,cellValue:any,keyValue:string,getUpdateList:React.Dispatch<React.SetStateAction<void>>}) {

    const handleUpdate = async ()=> {
        try {
          
          const response = await updatePaymentStatusAndRemarks(fieldName, value,keyValue);
          console.log("response",response)
          if (response.status) {
            setAlert({
              open: true,
              message: "updated successfully",
              serverity: "success",
            });
            getUpdateList();
          }
        } catch (error) {
          console.error("Error updating remarks:", error);
        }
    }
    const [value,setValue]=useState<any>(cellValue)
    const [IsEdit,setIsEdit]=useState(false)
    const inputRef = useRef<HTMLInputElement>(null);
    const [alert, setAlert] = useState({
    open: false,
    message: "",
    serverity: "",
  });
  return (
    <Box component={"div"} sx={{display:"flex",alignItems:"start" }}>
      {IsEdit ? (
        <input
          type="text"
          value={value}
          onChange={(e) => { setValue(e.target.value) }}
          multiple
            ref={inputRef}
          style={{ width: "100%", height: "25px", fontSize: "0.7rem",padding:"4px" }}
        />
      ) : (
        <span>{value}</span>
      )}
      {IsEdit ? (
        <IconButton
          color="success"
          size="small"
          onClick={() => {
            handleUpdate();
            setIsEdit(false);
            getUpdateList();
          }}
        >
          <DoneIcon sx={{fontSize:"18px"}} />
        </IconButton>
      ) : (
        <IconButton
          color="primary"
          size="small"
          onClick={() => {setIsEdit(true); inputRef.current?.focus()}}
        >
          <EditIcon sx={{fontSize:"15px"}}/>
        </IconButton>
      )}
      <ERPSnakBar
        open={alert.open}
        message={alert.message}
        serverity={alert.serverity}
        onClose={() => setAlert({ open: false, message: "", serverity: "" })}
      />
    </Box>
  )
}

export default UpdatePaymentStatusAndRemarks
